import React, { useContext, useEffect } from 'react';
import UserProvider from '@kbbsdk/global-sdk/navigation/web/mykbb/UserProvider';
import { Header as KbbHeader } from '@kbbsdk/global-sdk/navigation/web';
import { useDispatch, useSelector } from 'react-redux';
import UserContext from '@kbbsdk/global-sdk/navigation/web/mykbb/UserContext';
import { authDuck, birfDuck } from '../ducks';
import clientConfig from '@kbbsdk/config/clientConfig';
import getConfig from 'next/config';
import { useFeatures } from '@atc/features';
import { LITTLE_GUY_WEBCOMPONENT_FEATURE } from '../constants';

const AuthDuckUpdater = () => {
    const dispatch = useDispatch();
    const { isLoggedIn } = useContext(UserContext);
    const { publicRuntimeConfig } = getConfig();
    const { userApiUrl } = publicRuntimeConfig;
    useEffect(() => {
        clientConfig.userApiUrl = userApiUrl;
        if (isLoggedIn) {
            dispatch(authDuck.creators.setLoggedIn());
        } else {
            dispatch(authDuck.creators.setLoggedOut());
        }
    }, [userApiUrl, isLoggedIn, dispatch]);
    return false;
};
function KBBHeaderContainer({ navS3Data = {}, userwcbranch }) {
    const pageInstanceId = useSelector(birfDuck.selectors.getPgInst);
    const {
        littleguy_webcomponent: [enableWebComponent],
    } = useFeatures([LITTLE_GUY_WEBCOMPONENT_FEATURE]);

    return (
        <UserProvider pageRenderId={pageInstanceId}>
            <AuthDuckUpdater />
            <KbbHeader
                userwcbranch={userwcbranch}
                useWebComponent={enableWebComponent}
                suppressZipCode
                enableGtm
                withMyKbb
                navigation={navS3Data}
            />
        </UserProvider>
    );
}

export default React.memo(KBBHeaderContainer);
